import styled, { css } from 'styled-components';
import React, { FC } from 'react';
import { ErrorProps } from './types';
import { colors } from '@ch/common/const/color';
import { spacingStyle } from '@ch/common/const/spacing';
import { text } from '@ch/common/const/text';
import { FieldError } from './error-component';

const FormErrorChild: FC<ErrorProps> = ({ name, className }) => <FieldError {...{ name, className }} />;
export const FormErrorStyles = css`
  color: ${colors.error};
  font-size: ${text.md.fontSize}px;
  line-height: ${text.md.lineHeight}px;
  padding-top: 10px;
`;
export const FormErrorStyled = styled(FormErrorChild)<ErrorProps>`
  ${FormErrorStyles}
  ${props => spacingStyle(props)}
`;
